import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "screen-pause",
  "use": "screen-pause-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"screen-pause\"><path d=\"M7 4H6v5h1V4zm2 0h1v5H9V4z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1C.758 1 0 1.756 0 3v7c0 1.245.758 2 2 2h5.5v2H4v1h8v-1H8.5v-2H14c1.242 0 2-.756 2-2V3c0-1.245-.758-2-2-2H2zm-1 9V3c0-.418.588-1 1-1h12c.412 0 1 .582 1 1v7c0 .418-.588 1-1 1H2c-.412 0-1-.582-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol